import { parse } from 'qs';
const { addQueryArgs } = wp.url;

/**
 * Parse URL params.
 *
 * @return {Object}
 */
export function parseParams() {
  let params = window.location.href.split( '?' );
  if ( 1 === params.length ) {
    return {};
  }
  return parse( params[1].split( '#' )[0] );
}

/**
 *
 * @param {Object} defaults
 */
export function assignParams( defaults ) {
  let params = {};
  let urlParams = parseParams();
  for ( let prop in defaults ) {
    if ( ! defaults.hasOwnProperty( prop ) ) {
      continue;
    }
    const defaultValue = defaults[ prop ];
    if ( ! urlParams.hasOwnProperty( prop ) ) {
      params[ prop ] = defaultValue;
      continue;
    }
    let query = urlParams[ prop ];
    if ( 'object' === typeof defaultValue ) {
      // This is array.
      query = query.split(',');
      params[prop] = query.length ? query : defaultValue;
    } else if ( 'number' === typeof defaultValue) {
      params[prop] = parseInt( query, 10 ) || defaultValue;
    } else {
      // This is string.
      params[ prop ] = query || defaultValue;
    }
  }
  return params;
}

/**
 * Parse state and convert it to params.
 *
 * @param {Object} state
 * @return {Object}
 */
export function parseState( state ) {
  const props = {};
  const availableProps = [
    's', 'target', 'curPage', 'to', 'from', 'perPage',
  ];
  if ( 'advanced' === state.active ) {
    for ( let key of [ 'industries', 'news_cats', 'post_types' ] ) {
      availableProps.push( key );
    }
  }
  for( let key of availableProps ) {
    if ( ! state.hasOwnProperty( key ) ) {
      continue;
    }
    const value = state[ key ];
    if ( 'object' === typeof value) {
      // This is array.
      if ( value.length ) {
        props[key] = value.join(',');
      }
    } else {
      // This is string.
      if ( value ) {
        if ( 'curPage' === key && 1 === value ) {
          continue;
        }
        props[key] = value;
      }
    }
  }
  return props;
}

/**
 * Do search actions.
 *
 * @param {Object} state
 * @param {Boolean} shouldRecord
 * @param {String} path
 * @param {String} fromSuffix
 * @param {String} toSuffix
 * @returns {Promise}
 */
export function searchWithParams( state, shouldRecord = false, path = '', fromSuffix = ' 00:00:00', toSuffix = ' 23:59:59' ) {
  if ( ! path ) {
    path = '/plastic-search/v1/documents/wordpress';
    fromSuffix = ' 00:00:00';
  }
  const params = parseState( state );
  // Build query string for Plastic Search.
  const query = {};
  const terms = [];
  for ( let key in params ) {
    if ( ! params.hasOwnProperty( key ) ) {
      continue;
    }
    switch ( key ) {
      case 'industries':
      case 'news_cats':
        terms.push( params[ key ] );
        break;
      case 'target':
        query.field = params[ key ];
        break;
      case 'post_types':
        query.post_type = params[ key ];
        break;
      case 'curPage':
        query.page = params[ key ];
        break;
      case 'perPage':
        query.per_page = params[ key ];
        break;
      case 'from':
        query[key] = params[ key ] + fromSuffix;
        break;
      case 'to':
        query[key] = params[ key ] + toSuffix;
        break;
      default:
        query[key] = params[ key ];
        break;
    }
  }
  if ( terms.length ) {
    query.terms = terms.join( ',' );
  }
  if ( ! query.s ) {
    return Promise.reject( new Error( '検索キーワードが設定されていません。' ) );
  }
  const url = addQueryArgs( path, query );
  const results = {};
  // This search action should be recorded and push stated.
  if ( shouldRecord ) {
    const pushStateUrl = addQueryArgs( ( 'https:' === document.location.protocol ? 'https' : 'http' ) + '://' + window.location.hostname + window.location.pathname, params );
    const path = pushStateUrl.replace( /^https?:\/\/[^/]+/, '' );
    try {
      history.pushState( null, null, pushStateUrl );
    } catch (err) {
      window.console && console.log( err );
    }
    try {
      ga( 'send', 'pageview', path );
    } catch (err) {
      window.console && console.log( err );
    }
  }
  return wp.apiFetch( {
    path: url,
    parse: false
  } ).then( ( response ) => {
    results.total      = response.headers.get('X-WP-TotalPage');
    results.totalItems = response.headers.get('X-WP-Total');
    return response.json();
  } ).then( ( data ) => {
    results.items = data;
    return results;
  } );
}
